// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./data-fox-editor-type-image.png");
var dir = previousRequest.replace("data-fox-editor-type-image.png", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "data-fox-editor-type-image.png",
	name: "data-fox-editor-type-image",
	ext: ".png",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/data-fox-editor-type-image.png
// module id = 69
// module chunks = 4